import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { userGetters } from '@vsf-enterprise/commercetools';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzModal from '~/components/_next/molecules/AzModal.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzInput from '~/components/_next/atoms/AzInput.vue';
import { useToaster } from '~/composables/_next/useToaster';
import { useUser } from '~/composables/_next/useUser';
import { addEmailRule, addRequiredRule } from '~/helpers/validators/rules';
import { klaviyoBackInStockSubscriptionEvent } from '~/helpers/tracking/klaviyo';
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalBackInStockOrganism',
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    addEmailRule();
    addRequiredRule();
    var _useUiState = useUiState(),
      closeBackInStockModal = _useUiState.closeBackInStockModal,
      backInStockModalProduct = _useUiState.backInStockModalProduct;
    var _useToaster = useToaster(),
      showToast = _useToaster.show;
    var context = useNuxt2App();
    var _useUser = useUser(),
      user = _useUser.user;
    var i18n = context.i18n;
    var loggedInUserEmail = userGetters.getEmailAddress(user.value) || null;
    var customerEmail = ref(loggedInUserEmail);
    var modalRef = ref(null);
    var emailObserver = ref(null);
    var imageUrl = computed(function () {
      var _backInStockModalProd, _backInStockModalProd2, _backInStockModalProd3, _backInStockModalProd4;
      return (_backInStockModalProd = (_backInStockModalProd2 = backInStockModalProduct.value) === null || _backInStockModalProd2 === void 0 ? void 0 : (_backInStockModalProd3 = _backInStockModalProd2.images) === null || _backInStockModalProd3 === void 0 ? void 0 : (_backInStockModalProd4 = _backInStockModalProd3[0]) === null || _backInStockModalProd4 === void 0 ? void 0 : _backInStockModalProd4.url) !== null && _backInStockModalProd !== void 0 ? _backInStockModalProd : '';
    });
    function handleSubmitNotify() {
      return _handleSubmitNotify.apply(this, arguments);
    }
    function _handleSubmitNotify() {
      _handleSubmitNotify = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var observerValidity, _backInStockModalProd5, _backInStockModalProd6, variantId;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return emailObserver.value.validate();
            case 2:
              observerValidity = _context.sent;
              if (observerValidity) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              if (!backInStockModalProduct.value._id) {
                _context.next = 17;
                break;
              }
              _context.prev = 6;
              variantId = "".concat((_backInStockModalProd5 = backInStockModalProduct.value) === null || _backInStockModalProd5 === void 0 ? void 0 : _backInStockModalProd5._id, "-").concat((_backInStockModalProd6 = backInStockModalProduct.value) === null || _backInStockModalProd6 === void 0 ? void 0 : _backInStockModalProd6.id);
              closeBackInStockModal();
              _context.next = 11;
              return klaviyoBackInStockSubscriptionEvent(customerEmail.value, i18n.locale, variantId);
            case 11:
              showToast({
                title: i18n.t('modals.back-in-stock.toast.title'),
                description: i18n.t('modals.back-in-stock.toast.message'),
                iconColor: 'var(--c-primary-800)',
                iconName: 'checkmark'
              }, 2000);
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](6);
              showToast({
                title: _context.t0
              }, 2000);
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 14]]);
      }));
      return _handleSubmitNotify.apply(this, arguments);
    }
    expose({
      modalRef: modalRef
    });
    return {
      __sfc: true,
      closeBackInStockModal: closeBackInStockModal,
      backInStockModalProduct: backInStockModalProduct,
      showToast: showToast,
      context: context,
      user: user,
      i18n: i18n,
      loggedInUserEmail: loggedInUserEmail,
      customerEmail: customerEmail,
      modalRef: modalRef,
      emailObserver: emailObserver,
      imageUrl: imageUrl,
      handleSubmitNotify: handleSubmitNotify,
      ValidationObserver: ValidationObserver,
      ValidationProvider: ValidationProvider,
      AzImg: AzImg,
      AzModal: AzModal,
      AzButton: AzButton,
      AzInput: AzInput
    };
  }
});